import Reveal from "@/components/Reveal";
import { Martini, UtensilsCrossed } from "lucide-react";

const floors = [
  {
    icon: Martini,
    tag: "Piano Terra",
    title: "La Festa",
    text: "Accoglie gli ospiti con un punto bar scenografico per iniziare la serata, per poi aprirsi su una pista da ballo con console DJ e impianti audio-luci di ultima generazione: la scenografia perfetta per chi vuole trasformare la propria serata in puro divertimento.",
    testid: "floor-piano-terra",
  },
  {
    icon: UtensilsCrossed,
    tag: "Primo Piano",
    title: "La Cena",
    text: "Salendo al primo piano, l'atmosfera si fa intima e raffinata. Una sala cena riservata e luminosa accoglie cene servite o buffet di classe, offrendo uno spazio caldo e tranquillo per chiacchierare, fare i brindisi più importanti e godersi il gusto della convivialità prima di scendere a ballare.",
    testid: "floor-primo-piano",
  },
];

const spaces = [
  {
    name: "La Pista da Ballo",
    img: "/loc-serate.webp",
    alt: "Ospiti che ballano in pista al Club tra luci colorate",
    span: "md:col-span-4",
  },
  {
    name: "I Divanetti",
    img: "/loc-lounge.webp",
    alt: "L'area divanetti del Club con tavolini e luci colorate",
    span: "md:col-span-4",
  },
  {
    name: "La Sala Cena",
    img: "/loc-sala.webp",
    alt: "La sala cena del Club con tavoli eleganti e sedie bianche",
    span: "md:col-span-4",
  },
];

export default function Spazi() {
  return (
    <section id="location" data-testid="location-section" className="bg-linen px-6 py-28 text-midnight md:py-40 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.35em] text-midnight/60">
            <span className="h-px w-10 bg-midnight/40" /> La Location
          </p>
          <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight sm:text-5xl md:text-6xl">
            Mix tra eleganza e <span className="italic text-dusty">divertimento</span>.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base font-light leading-relaxed text-midnight/70 md:text-lg">
            Club Star Eventi è la sintesi perfetta tra eleganza, raffinatezza
            e divertimento. La nostra struttura è pensata per soddisfare ogni
            desiderio: dal brindisi intimo e rilassato con le persone più
            care, fino alla festa dinamica a ritmo di musica. Grazie a spazi
            modulabili e un'atmosfera curata nei minimi dettagli, riusciamo a
            mettere d'accordo sia chi cerca una serata elegante e tranquilla,
            sia chi vuole scatenarsi in pista fino a tarda notte.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-10 sm:grid-cols-2">
          {floors.map((f, i) => (
            <Reveal key={f.tag} delay={i * 0.12}>
              <div className="border-l-2 border-sand/60 pl-6" data-testid={f.testid}>
                <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-sand">
                  <f.icon className="h-4 w-4" /> {f.tag}
                </p>
                <h3 className="mt-2 font-serif text-2xl sm:text-3xl">{f.title}</h3>
                <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-midnight/60 md:text-base">
                  {f.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-12">
          {spaces.map((s, i) => (
            <Reveal key={s.name} delay={(i % 2) * 0.12} className={s.span}>
              <div
                className="group relative aspect-[2000/1157] overflow-hidden"
                data-testid={`space-card-${s.name.toLowerCase().replace(/\s/g, "-")}`}
              >
                <img
                  src={s.img}
                  alt={s.alt}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
